import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IHistoryRecordViewModel} from "../../../../services/gaming-history/models/record/history-record-view-model.interface";
import {HistoryRecordEndSectionBox} from "./boxes/end-section/history-record-end-section.box";
import {HistoryRecordAmountsContainerBox} from "./boxes/end-section/amounts/history-record-amounts-container.box";
import {GamingHistoryRecordAmountComponent} from "./gaming-history-record-amount.component";
import {CyClass} from "../../../../../common/cy-classes";
import {observer} from "mobx-react";
import {GamingHistoryRecordContentMiddleSectionComponent} from "./gaming-history-record-content-middle-section.component";
import {HistoryMoreDetailsButtonComponent} from "./history-more-details-button.component";

interface GamingHistoryRecordEndSectionComponentProps {
    record: IHistoryRecordViewModel;
    showMoreDetails: boolean;
}


export const GamingHistoryRecordContentEndSectionComponent = observer(
    class GamingHistoryRecordContentEndSectionComponent extends OrbitComponent<GamingHistoryRecordEndSectionComponentProps> {

        private _onClickHandler = async () => {
            if(!this.props.record.supportsDetailHistory) {
                return;
            }

            await this.props.record.openDetailHistory();
        }



        private _renderMoreDetailsButton() {

            if(!this.props.showMoreDetails) {
                return null;
            }
            if(!this.props.record.supportsDetailHistory && !this.props.record.detailsHistoryNotAllowedOnCurrentPlatformMessage) {
                return null;
            }

            return (
                <HistoryMoreDetailsButtonComponent className={CyClass('cy-history-more-details')}
                                                   onClick={this._onClickHandler}
                                                   isClickable={this.props.record.supportsDetailHistory}
                                                   buttonText={this.services.translation.translate('GAMING_HISTORY_MORE_DETAILS')}
                                                   notAllowedMessage={this.props.record.detailsHistoryNotAllowedOnCurrentPlatformMessage}/>
            );

        }

        private _renderMiddleSection() {
            if(this.services.mediaQuery.sAndBelow) {
                return (<GamingHistoryRecordContentMiddleSectionComponent record={this.props.record}/>);
            }
            return null;
        }

        render() {
            return (
                <HistoryRecordEndSectionBox>
                    {this._renderMiddleSection()}
                    <HistoryRecordAmountsContainerBox>
                        {this.props.record.amounts.map(amount => <GamingHistoryRecordAmountComponent key={amount.description} amount={amount}/>)}
                    </HistoryRecordAmountsContainerBox>
                    {this._renderMoreDetailsButton()}
                </HistoryRecordEndSectionBox>
            );
        }
    }
);